/* DUPLO Landing — Olistic
  Toggle Women / Next / Men. Lee los datos de cada variante desde data- attrs
 * en los <button class="pack__tab"> renderizados por Liquid. Esto evita meter
 * URLs hardcoded o {{ asset_url }} dentro del .js.
 */

(function () {

  var root = document.querySelector('.duplo-landing-root');
  if (!root) return;

  var tabs = root.querySelectorAll('.pack__tab');
  var card = root.querySelector('[data-card]');
  if (!card || !tabs.length) return;

  var img   = card.querySelector('[data-img]');
  var title = card.querySelector('[data-title]');
  var age   = card.querySelector('[data-age]');
  var core  = card.querySelector('[data-core]');
  var oldEl = card.querySelector('[data-old]');
  var now   = card.querySelector('[data-now]');
  var day   = card.querySelector('[data-day]');

  var heroVideo = root.querySelector('#hero-video');

  var form    = root.querySelector('[data-duplo-form]');
  var variant = root.querySelector('[data-duplo-variant]');

  function selectVariant(tab) {
    var d = tab.dataset;

    // Visual state of tabs
    tabs.forEach(function (t) {
      t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
    });

    // Theme accent (drives the --accent CSS var on .duplo-landing-root[data-pack])
    if (d.target) root.setAttribute('data-pack', d.target);

    // Card content
    if (img && d.img)      { img.src = d.img;      img.alt = d.imgAlt || ''; }
    if (title && d.title)  title.textContent = d.title;
    if (age && d.age)      age.textContent = d.age;
    if (core && d.core)    core.textContent = d.core;
    if (oldEl && d.old)    oldEl.textContent = d.old;
    if (now && d.now)      now.textContent = d.now;
    if (day && d.day)      day.textContent = d.day;

    // Hero video swap (some variants may not have a video)
    if (heroVideo) {
      if (d.video) {
        heroVideo.style.display = '';
        heroVideo.src = d.video;
        if (d.img) heroVideo.poster = d.img;
        heroVideo.load();
      } else {
        heroVideo.removeAttribute('src');
        if (d.img) heroVideo.poster = d.img;
        heroVideo.load();
      }
    }

    // Cart form: update hidden variant_id so Add-to-Cart sends the right one
    if (variant && d.variantId) variant.value = d.variantId;
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () { selectVariant(tab); });
  });

  // Preselección por URL: ?tab=next  (valores válidos: women, next, men)
  var tabParam = new URLSearchParams(window.location.search).get('tab');
  var fromUrl  = tabParam && root.querySelector('.pack__tab[data-target="' + tabParam + '"]');

  // Initialize: URL param > aria-selected=true en el HTML > primer tab
  var initial = fromUrl || root.querySelector('.pack__tab[aria-selected="true"]') || tabs[0];
  if (initial) selectVariant(initial);

})();